import React from "react";
import { XIcon } from "@heroicons/react/solid";
import twFocusClass from "utils/twFocusClass";
import { useTranslation } from "react-i18next";

export interface ButtonCloseProps {
  className?: string;
  onClick?: () => void;
}

const ButtonClose: React.FC<ButtonCloseProps> = ({
  className = "",
  onClick = () => {},
}) => {
	const { t } = useTranslation();
  return (
    <button
	  type="button"
	  aria-label={t('common.close')}
      className={
        `w-8 h-8 flex items-center justify-center rounded-full text-neutral-700 dark:text-neutral-300 hover:bg-neutral-100 dark:hover:bg-neutral-700 ${className} ` +
        twFocusClass()
      }
      onClick={onClick}
    >
	  <span className="sr-only">{t('common.close')}</span>
      <XIcon className="w-5 h-5" />
    </button>
  );
};

export default ButtonClose;
